export default "__VITE_ASSET__CTkdEiiS__"